import React, { Component } from "react";
import { connect } from 'react-redux';
import ReactTable from "react-table";
import {
    Grid,
    Row,
    Col, OverlayTrigger, Popover, Modal,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { brandActions } from 'redux/actions/brand-actions';
import { withRouter, Link } from 'react-router-dom';
import downloadIcon from '../../../assets/img/download_icon.png';
import 'react-table/react-table.css';
import BrandsDropdown from "./BrandsDropdown";
import { hasPermission } from "../../../helper/hasPermission";
import { adminLabels } from "../../../redux/constant/admin-label-constant";
import { confirmAlert } from "react-confirm-alert";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";
import { helperFunctions as HF } from "../../../helper/helperFunctions";
import BrandDataDuplicateForm from "./Forms/BrandDataDuplicateForm";

class BrandData extends Component {
    constructor(props) {
        super(props);
        const { brandId } = this.props.match.params;
        this.state = {
            brandId: brandId,
            sorted: '',
            filtered: '',
            pageSize: 10,
            page: 1,
            brand: {},
            searchable_columns: '',
            showDropdown: !this.props.match.params.brandId ? true : false,
            ids_search: '',
            all_checked: false,
            addModal: false,
        }

        brandId ? this.props.getBrandDataWithKeyCall(brandId) : null;
    }

    deleteConfirmProduct(id, desc = "Are you sure to remove this product/s?") {
        console.log(desc);
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete
                        typeName="Product/s"
                        description={desc}
                        cartMsg={"These Items might be present in cart!"}
                        onClosePro=
                        {
                            onClose
                        }
                        deleteType=
                        {
                            (cart_check) => {
                                this.props.deleteBrandProductCall({
                                    brand: {
                                        ...this.state.brand,
                                        product_attributes: {}
                                    },
                                    brand_id: this.state.brand.id,
                                    short_code: this.state.brand.short_code,
                                    product_ids: id,
                                    delete_cart_items: cart_check
                                }).then(res => {
                                    this.brandProductPaginationData(this.state.page, this.state.filtered, this.state.sorted, this.state.pageSize);
                                    this.setState({
                                        all_checked: false,
                                    })
                                })
                            }

                        }
                    />
                )
                    ;
            }
        });
    }

    handleDeleteItem = (e, id) => {
        const mutated_array = this.state.brandProductData.map(item => {
            if (item.id === id) {
                item.selected = e.target.checked;
            }
            return item;
        })
        this.setState({
            brandProductData: mutated_array
        })
    }

    handleDeleteAllItems = () => {
        const delete_ids = [];
        this.state.brandProductData.filter(item => {
            if (item.selected) {
                delete_ids.push(item.id);
            }
        })
        this.deleteConfirmProduct(delete_ids, "Are you sure you want to delete the selected items?");
    }

    checkAll = (e) => {
        this.setState({
            all_checked: e.target.checked
        })
    }

    makeDynamicColumns = (objectArray) => {
        var temp = [];
        temp.push(
            {
                Header: 'Prod Filter',
                accessor: 'prod_filter',
                className: "action-center",
                show: true,
            }
        );
        for (var i in objectArray) {
            if (objectArray[i]['data_type'] !== 'url') {
                temp.push(
                    {
                        Header: objectArray[i]['title'],
                        accessor: objectArray[i]['db_column'],
                        className: "action-center",
                        show: objectArray[i]['show_on_grid'],
                    }
                );
            } else if (objectArray[i]['data_type'] === 'url') {
                temp.push(
                    {
                        Header: objectArray[i]['title'],
                        accessor: objectArray[i]['db_column'],
                        className: "action-center",
                        show: objectArray[i]['show_on_grid'],
                        Cell: ({ value, original }) => (
                            <div>
                                {
                                    value ?
                                        JSON.parse(value).new_url ?
                                            <a target="_blank"
                                                href={process.env.REACT_APP_S3_PATH + JSON.parse(value).new_url}
                                                title={JSON.parse(value).url_title ? JSON.parse(value).url_title : 'Download'}
                                                download><img src={downloadIcon} alt='img' /></a>
                                            :
                                            <a target="_blank"
                                                href={process.env.REACT_APP_S3_PATH + JSON.parse(value).original_url}
                                                url_title={JSON.parse(value).url_title ? JSON.parse(value).url_title : 'Download'}
                                                download><img src={downloadIcon} alt='img' /></a>
                                        :
                                        ''
                                }
                            </div>
                        )
                    }
                );
            }
        }
        temp.push(
            {
                Header: (
                    <React.Fragment>
                        <div>
                            <label style={{marginTop: '4px' }}>
                                <span style={{ color: 'white' }}>Actions</span>
                            </label>
                            <span style={{ paddingLeft: '5px' }}>
                                <input
                                    type="checkbox"
                                    style={{
                                        float: "left",
                                        margin: "4px 6px",
                                        width: '25px',
                                        height: '25px',
                                    }}
                                    checked={this.state.all_checked}
                                    onChange={this.checkAll}
                                />
                            </span>
                        </div>
                    </React.Fragment>
                ),
                classname: "action-center",
                accessor: "id",
                sortable: false,
                minWidth: 120,
                Cell: ({ value, original }) => (
                    <div>
                        <span
                            style={{ paddingRight: '5px' }}
                        >
                            <input
                                type="checkbox"
                                style={{
                                    float: "left",
                                    margin: "4px 6px",
                                    width: '25px',
                                    height: '25px',
                                }}
                                checked={original.selected}
                                onChange={(e) => {
                                    this.handleDeleteItem(e, value)
                                }}
                            />
                        </span>
                        <OverlayTrigger placement="bottom" overlay={<Popover
                            id="tooltip">{hasPermission('list-delete') ? `Delete Product` : adminLabels.DONT_ALLOW}</Popover>}>
                            <span style={{paddingLeft: '10px'}}> 
                                {
                                    hasPermission('list-delete') &&
                                    <button type='button' style={{transform: "scale(1.4)", marginTop: '2px'}} className="deleteIcon orderDetailsAction"
                                        onClick={() => this.deleteConfirmProduct([value])}>&nbsp;</button>
                                }
                                {
                                    !hasPermission('list-delete') &&
                                    <button type='button' style={{transform: "scale(1.4)", marginTop: '2px'}}
                                        className="deleteIcon orderDetailsAction button_disabled">&nbsp;</button>
                                }
                            </span>
                        </OverlayTrigger>
                    </div>
                ),
            }
        )
        return temp;
    }

    brandProductPaginationData = (page = this.state.page, filtered = '', sorted = this.state.sorted, pageSize = this.state.pageSize, product_ids = []) => {
        this.setState({
            pageSize: pageSize,
            page: page
        }, async () => {
            if (this.state.ids_search) {
                this.searchById();
                return;
            }
            try {
                const res = await this.props.getBrandProductDataCall(this.state.brandId, page, this.state.filtered, sorted, this.state.pageSize, {
                    product_ids,
                    products_for_listing: true
                });
                this.setState({
                    searchable_columns: res.result.search_columns
                })
                console.log('ressss', res);
            } catch (e) {
                console.log('error', e);
            }
        })
    }

    filterChange = e => {
        this.setState({ filtered: e.target.value }, async () => {
            if (this.state.ids_search) {
                this.setState({
                    ids_search: ''
                })
            }
            try {
                const res = await this.props.getBrandProductDataCall(
                    this.state.brandId,
                    this.state.page,
                    this.state.filtered,
                    this.state.sorted,
                    this.state.pageSize,
                    { products_for_listing: true }
                )
                this.setState({
                    searchable_columns: res.result.search_columns
                })
                console.log('ressss', res);
            } catch (e) {
                console.log('error', e);
            }
        });
    };

    handleText = e => {
        this.setState({
            ids_search: e.target.value.replace(/\s/g, '')
        })
    }

    searchById = (e) => {
        const { id, short_code, title } = this.state.brand;
        this.setState({
            filtered: ''
        })
        const ids_array = this.state.ids_search.split(',');
        if (ids_array.length > 1000) {
            alert('Search IDS cannot be greater than 1000!')
            return;
        }
        this.props.getProductsWithIds({
            brand_id: id,
            brand_short_code: short_code,
            brand_title: title,
            pageSize: this.state.pageSize,
            page: this.state.page,
            product_ids: this.state.ids_search.split(',')
        });
        // this.brandProductPaginationData('','','','',ids_array)
        // this.props.getBrandProductDataCall(
        //     this.state.brandId, this.state.page, '', this.state.sorted, this.state.pageSize, {product_ids: ids_array, products_for_listing: true}
        // )
        // ;
    }

    clearTextArea = () => {
        this.setState({ ids_search: '', filtered: '' });
        this.brandProductPaginationData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.brand !== this.props.brand) {
            this.setState({ brand: this.props.brand })
        }

        if (prevProps.brandProductData !== this.props.brandProductData) {
            const select_added_array = Array.isArray(this.props.brandProductData) ? this.props.brandProductData.map(item => {
                return { ...item, selected: false }
            }) : [];
            this.setState({ brandProductData: select_added_array })
        }
        if (prevProps.brandProductDatacurrent_page !== this.props.brandProductDatacurrent_page) {
            this.setState({ page: this.props.brandProductDatacurrent_page })
        }
        if (this.state.all_checked !== prevState.all_checked) {
            const mapped_arr = this.props.brandProductData.map(item => {
                return {
                    ...item,
                    selected: this.state.all_checked
                }
            })
            this.setState({
                brandProductData: mapped_arr
            })
        }
    }

    getFullState = state => {
        this.setState(prevState => ({
            brandId: state.model_id
        }), () => {
            if (this.state.brandId) {
                this.props.getBrandDataWithKeyCall(this.state.brandId);
                this.brandProductPaginationData();
            }
        });
    }

    handleFormSubmit = (data) => {
        if (data.duplicated) {
            this.brandProductPaginationData();
        }
    }

    render() {
        const { loading, brandProductDatapages, } = this.props;
        const { brand, brandProductData } = this.state;
        let columns = [
            {
                Header: "Orders Listing",
                headerClassName: 'headerPagination',
                Cell: () => {
                    return <div style={{ overflow: 'auto' }}></div>
                },
                columns: this.makeDynamicColumns('product_attributes' in brand ? brand.product_attributes : [])
            },
        ];
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <div className="flexElem spaceBetween" style={{ alignItems: "flex-end" }}>
                                                    <div className="col-md-5 mt-md">
                                                        {
                                                            !this.state.brandId &&
                                                            <h4>
                                                                Please Select A Brand!
                                                            </h4>
                                                        }
                                                        <div className="brand-info well well-sm">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            {
                                                                                brand.logo_path &&
                                                                                <img height="100" src={brand.logo_path}
                                                                                    alt="Logo" />
                                                                            }
                                                                        </td>

                                                                        <td>
                                                                            <div className="mb-sm ml-md">Brand Name: <span
                                                                                className="linkColor">{brand.title || 'Not Available'}</span>
                                                                            </div>

                                                                            <div className="mt-sm ml-md">Brand code: <span
                                                                                className="linkColor">{brand.short_code || 'Not Available'}</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    {this.state.showDropdown && (
                                                        <div
                                                            className="col-md-4 mt-md" style={{ marginBottom: '25px' }}
                                                        >
                                                            <BrandsDropdown
                                                                onReturnFullState={this.getFullState}
                                                                stateProp={this.state}
                                                            />
                                                        </div>
                                                    )}
                                                    {
                                                        this.state.searchable_columns &&
                                                        <div className="col-md-4 mt-md" style={{ marginBottom: '25px' }}>
                                                            <div>Searchable
                                                                Columns: {this.state.searchable_columns}, Product Filter
                                                            </div>
                                                            <div className="searchBox" style={{ maxWidth: '100%' }}>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Products"
                                                                    className="form-control"
                                                                    value={this.state.filtered}
                                                                    onChange={
                                                                        this
                                                                            .filterChange
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div>
                                                    <textarea cols="30" rows="5" style={{ width: "100%" }}
                                                        value={this.state.ids_search}
                                                        onChange={this.handleText}
                                                        placeholder="Search by ID (Maximum 1000 at a time)"
                                                    >
                                                    </textarea>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={this
                                                        .searchById}
                                                        style={{
                                                            maxWidth: '120px',
                                                            marginTop: '10px',
                                                            marginRight: '15px'
                                                        }}
                                                        className="customBtn btnBlack btn-lg">
                                                        Search
                                                    </button>
                                                    <button type="button" onClick={this.clearTextArea}
                                                        style={{
                                                            maxWidth: '120px',
                                                            marginTop: '10px',
                                                            marginRight: '15px',
                                                            backgroundColor: 'tomato'
                                                        }}
                                                        className="customBtn btnBlack btn-lg">
                                                        Clear
                                                    </button>
                                                </div>

                                                <div className="mt-md text-right">
                                                    <button type="button"
                                                        style={
                                                            {
                                                                maxWidth: '220px',
                                                                marginRight: '15px',
                                                                backgroundColor: 'tomato'
                                                            }}
                                                        onClick={() => {
                                                            this.setState({ addModal: true })
                                                        }}
                                                        className="customBtn btnBlack btn-lg"
                                                    >
                                                        Duplicate Products
                                                    </button>
                                                    <button type="button" onClick={this.handleDeleteAllItems}
                                                        style={{ maxWidth: '220px', marginRight: '15px' }}
                                                        className="customBtn btnBlack btn-lg">
                                                        Remove Selected
                                                    </button>
                                                </div>

                                                {
                                                    Object.keys(this.props.brand || {}).length > 0 &&
                                                    <Modal show={this.state.addModal}
                                                        onHide={HF.closeModal.bind(this, "addModal")}
                                                        aria-labelledby="ModalHeader"
                                                        backdrop={false}>
                                                        <Modal.Header closeButton>
                                                            <Modal.Title id='ModalHeader'
                                                                className="headerTitle">Duplicate Products
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <div className="row">
                                                                <div className="col-md-8 col-md-offset-2">
                                                                    <BrandDataDuplicateForm
                                                                        closeModel={HF.closeModal.bind(this, "addModal")}
                                                                        brand={this.props.brand}
                                                                        searchable_columns={this.state.searchable_columns}
                                                                        product_ids={this.state.ids_search}
                                                                        product_filter_val={this.state.filtered}
                                                                        return_submitted_data={this.handleFormSubmit}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Modal.Body>
                                                    </Modal>
                                                }

                                                <div className="col-md-12 mt-sm">
                                                    {
                                                        'product_attributes' in brand ?
                                                            <ReactTable
                                                                data={brandProductData}
                                                                loading={loading}
                                                                columns={columns}
                                                                pageSizeOptions={[10, 25, 50, 100, 250, 500, 1000]}
                                                                pageData={this.brandProductPaginationData}
                                                                pages={brandProductDatapages}
                                                                defaultPageSize={10}
                                                                className="-striped listing responsive"
                                                                manual
                                                                onFetchData={(state, instance) => {
                                                                    var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                                    state.pageData(state.page + 1, state.filtered, sort, state.pageSize);
                                                                }}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </Row>
                                        </Grid>
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        getBrandDataWithKeyCall: (id) => {
            return dispatch(brandActions.getBrandDataWithKey(id))
        },
        getBrandProductDataCall: (id, page, filter, sort, pageSize, data) => {
            return dispatch(brandActions.getBrandProductData(id, page, filter, sort, pageSize, data))
        },
        getProductsWithIds: (data) => {
            return dispatch(brandActions.getProductsWithIds(data))
        },
        deleteBrandProductCall: (id) => {
            return dispatch(brandActions.deleteBrandProduct(id))
        },
    });
};

function mapStateToProps(state) {
    const {
        loading,
        brand,
        brandProductDatacurrent_page,
        brandProductDatapages,
        brandProductData,
        searchable_columns
    } = state.brandReducer;
    return {
        loading, brand, brandProductDatacurrent_page, brandProductDatapages, brandProductData, searchable_columns
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandData));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandData.jsx